import * as React from 'react';
import { ShareButton as ShareButtonComponent } from '../../components/ShareButton';
import { CustomTooltip } from '@cian/ui-kit';
import { useSelector } from 'react-redux';
import { gaLabelSelector, newbuildingUrlSelector, newbuildingDisplayNameSelector } from '../../selectors/newbuilding';
import { SharingPopup } from '../../components/SharingPopup';

export const ShareButton = () => {
  const newbuildingUrl = useSelector(newbuildingUrlSelector);
  const gaLabel = useSelector(gaLabelSelector);
  const newbuildingName = useSelector(newbuildingDisplayNameSelector);

  const [isOpenPopup, setOpenPopup] = React.useState(false);

  const buttonRef = React.useRef<HTMLButtonElement>(null);

  const onClick = () => {
    setOpenPopup(true);
  };

  const handleSocialLink = (socialType: string) => {
    let url: string | undefined;

    const link = `${newbuildingUrl}ipoteka-zhk/`;
    const utmMarked = `?utm_medium=social_repost&utm_campaign=card_social_repost&utm_source=${socialType}`;

    switch (socialType) {
      case 'vk':
        url = [
          `https://vk.com/share.php?url=${encodeURIComponent(link + utmMarked)}`,
          `title=${encodeURIComponent('Планировки в ' + newbuildingName)}`,
          `description=${encodeURIComponent(gaLabel)}`,
          `noparse=true`,
        ].join('&');
        break;

      case 'ok':
        url = [
          `https://connect.ok.ru/offer?url=${encodeURIComponent(link + utmMarked)}`,
          `title=${encodeURIComponent('Планировки в ' + newbuildingName)}`,
        ].join('&');
        break;

      default:
        return;
    }

    window.open(url, '');
  };

  return (
    <>
      <ShareButtonComponent onClick={onClick} ref={buttonRef} />
      <CustomTooltip
        content={<SharingPopup url={`${newbuildingUrl}ipoteka-zhk/`} onClick={handleSocialLink} />}
        anchorRef={buttonRef}
        size="S"
        theme="white"
        maxWidth={400}
        onClose={() => setOpenPopup(false)}
        open={isOpenPopup}
        placement="bottom-start"
        arrow
        closeButton
        flip
        outside
        preventOverflow
        portal={true}
      />
    </>
  );
};
